// assets/shipping_selector.js
(function ($) {

  /********************
   * BASIC POPUP CONTROL
   ********************/
  function openModal() {
    $('.shipping_selecter_popup').addClass('active');
  }

  function closeModal() {
    $('.shipping_selecter_popup').removeClass('active');
  }

  // Both buttons open popup
  $(document).on('click', '#header_delivery_button', openModal);
  $(document).on('click', '#header_change_delivery_button', openModal);
  $(document).on('click', '#closeSelectorPopup', closeModal);

  /********************
   * CART SUBMIT GUARD
   ********************/
  let allowCartSubmit = false

  $(document).on('submit', '#cart-form', function (event) {
    const form = this;

    if (allowCartSubmit) {
      return true;
    }

    const submitter =
      event.originalEvent && event.originalEvent.submitter
        ? event.originalEvent.submitter
        : null;

    event.preventDefault();

    const data = getSavedSelection();

    // No shipping selected → open popup, close drawer, block submit
    if (!data) {
      openModal();

      const drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl && typeof drawerEl.close === 'function') {
        drawerEl.close();
      }

      return false;
    }

    // Re-validate lead time at submit — catches selections that aged past the noon
    // cutoff while the cart was open (page-load check alone is not enough).
    if (isSlotExpired(data)) {
      localStorage.removeItem('localDeliveryHeader');
      $(document).trigger('pitzi:selectionExpired');
      alert('המועד שבחרת כבר אינו זמין. אנא בחרו מועד חדש.');
      openModal();

      const drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl && typeof drawerEl.close === 'function') {
        drawerEl.close();
      }

      return false;
    }

    // Collection availability-window guard (e.g. holiday edition).
    // Delivery/pickup carry a future dayIso; fast has none → validate today's date.
    var checkIso = data.mode === 'fast' ? todayIso() : data.dayIso;
    var offending = findOutOfWindowLine(form, checkIso);
    if (offending) {
      alert(composeWindowMessage(offending));
      openModal();

      const drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl && typeof drawerEl.close === 'function') {
        drawerEl.close();
      }

      return false;
    }

    // Per-product blocked-date guard (single-day blackout, e.g. kitchen closed one
    // specific day, unlike the window above which is a continuous available range).
    var blockedLine = findBlockedDateLine(form, checkIso);
    if (blockedLine) {
      alert(composeBlockedMessage(blockedLine));
      openModal();

      const drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl && typeof drawerEl.close === 'function') {
        drawerEl.close();
      }

      return false;
    }

    // Holiday minimum-order guard (date-gated cart minimum, e.g. chag).
    // Config comes from the `holiday_minimum_order` metaobject, exposed in
    // layout/theme.liquid as window.holidayMinimumOrder. Reuses the same
    // checkIso as the window guard above (today's date for fast delivery).
    var holidayMin = findHolidayMinimum(checkIso);
    if (holidayMin) {
      var subtotalIls = parseInt(form.dataset.cartSubtotal || '0', 10) / 100;
      if (subtotalIls < holidayMin.amount) {
        alert(holidayMin.blockingMessage);
        openModal();

        const drawerEl = document.querySelector('cart-drawer-component');
        if (drawerEl && typeof drawerEl.close === 'function') {
          drawerEl.close();
        }

        return false;
      }
    }

    // We have selection → save to cart attributes, then re-submit
    saveShippingToCartAttributes(data)
      .then(() => {
        allowCartSubmit = true;

        if (typeof form.requestSubmit === 'function') {
          if (submitter) {
            form.requestSubmit(submitter);
          } else {
            form.requestSubmit();
          }
        } else if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        } else {
          form.submit();
        }
      })
      .catch((err) => {
        console.error('Failed saving shipping attributes', err);
        alert('שמירת פרטי המשלוח נכשלה, אנא נסו שוב או רעננו את העמוד');
      });

    return false;
  });

  /********************
   * SAVE BUTTON IN POPUP
   ********************/
  $(document).on('click', '#save_delivery', function () {
    const selection = readDeliveryFromPopup();

    if (!selection) {
      alert('נא לבחור תאריך, שעה ויעד אספקה');
      return;
    }

    saveDeliverySelection(selection);
    updateHeaderDeliveryStatus();
    closeModal();

    // Eagerly persist to cart attributes so any path to checkout already carries them.
    // Best-effort: failures here are logged; the cart-form submit handler retries and
    // surfaces the error to the customer if it still fails at submit time.
    saveShippingToCartAttributes(selection).catch((err) => {
      console.warn('Eager cart-attribute write failed; will retry at submit:', err);
    });
  });

  /********************
   * INIT HEADER ON LOAD
   ********************/
  $(document).ready(function () {
    setTimeout(function () {
      updateHeaderDeliveryStatus();
      $('#delivery_loader').css('display', 'none');
      $('.header_delivery_content').css('display', 'flex');
    }, 1000);
  });

  /********************
   * TAB SWITCHER
   ********************/
  $(document).on('click', '.shipping_tab', function () {
    const target = $(this).data('open');

    $('.shipping_tab').removeClass('active');
    $(this).addClass('active');

    $('.shipping_selector_content_block').removeClass('active');
    $('#' + target).addClass('active');

    $('.shipping_selector_content').attr('data-active', target);
  });

  /********************
   * POPUP → SELECTION → HEADER
   ********************/

  function findZoneTitleForCity(cityName) {
    const zones = (window.localDeliveryCapacity && window.localDeliveryCapacity.delivery && window.localDeliveryCapacity.delivery.zones) || [];
    const target = (cityName || '').trim();
    if (!target) return null;
    const match = zones.find((z) => (z.cities || []).some((c) => (c || '').trim() === target));
    return match ? match.title : null;
  }

  function buildShippingSelectionKey(data) {
    if (data.mode === 'delivery') {
      // cityValue = zone title (set in buildCitySelect)
      return `delivery:${data.cityValue}:${data.dayIso}:${data.timeHandle}`;
    }
    if (data.mode === 'pickup') {
      // storeHandle = pickup store handle
      return `pickup:${data.storeHandle}:${data.dayIso}:${data.timeHandle}`;
    }
    if (data.mode === 'fast') {
      // Resolve zone title from city so checkout pricing can match by zone.
      // Fallback to fast:<city> preserves the legacy shape if the city isn't in any zone.
      const zoneTitle = findZoneTitleForCity(data.cityValue);
      return zoneTitle ? `fast:${zoneTitle}:${data.cityValue}` : `fast:${data.cityValue}`;
    }
    return null;
  }

  async function saveShippingToCartAttributes(data) {
    const dateStr = `${data.dateLabel} ${data.rangeLabel}`;
    const selectionKey = buildShippingSelectionKey(data);

    const body = new URLSearchParams();
    body.set('attributes[תאריך אספקה עתידי]', dateStr || '');
    if (selectionKey) {
      body.set('attributes[_shipping_selection]', selectionKey);
    }

    // Ask for fresh HTML of any cart-items-component section(s) on the page
    // (cart drawer and/or the /cart page) in the same request, same
    // sections/sections_url shape component-cart-items.js's updateQuantity()
    // already uses. Without this, cart-summary.liquid — rendered in that same
    // section — keeps showing whatever was last rendered (e.g. the generic
    // ₪120 caption) until a full page reload, even though the attribute this
    // selection depends on just changed.
    const sectionIds = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    });
    if (sectionIds.size) {
      body.set('sections', Array.from(sectionIds).join(','));
      body.set('sections_url', window.location.pathname);
    }

    console.log('saved to cart attributes:', dateStr, selectionKey);

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body
    });

    if (!res.ok) {
      throw new Error(`Cart update failed: HTTP ${res.status}`);
    }

    // Best-effort UI refresh only — the attribute write above already
    // succeeded regardless of what happens here, so failures are logged, not
    // thrown. Worst case the button/caption stays stale until next render,
    // same as before this change.
    if (sectionIds.size) {
      try {
        const responseJson = await res.json();
        if (responseJson && responseJson.sections) {
          const { morphSection } = await import('@theme/section-renderer');
          Object.keys(responseJson.sections).forEach((id) => {
            morphSection(id, responseJson.sections[id]);
          });
        }
      } catch (err) {
        console.warn('Section refresh after cart attribute save failed:', err);
      }
    }
  }

  function getSavedSelection() {
    try {
      const raw = localStorage.getItem('localDeliveryHeader') || '{}';
      const data = JSON.parse(raw);
      if (!data || !data.mode) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function readDeliveryFromPopup() {
    const $activeBlock = $('.shipping_selector_content_block.active');
    if (!$activeBlock.length) return null;

    const activeId = $activeBlock.attr('id');
    let mode = 'delivery';
    if (activeId === 'select_pickup') mode = 'pickup';
    if (activeId === 'select_fast') mode = 'fast';

    const $day = $activeBlock.find('.day-btn.selected');
    const $time = $activeBlock.find('.time-btn.selected');

    if (mode != 'fast') {
      if (!$day.length || !$time.length) {
        return null;
      }
    }

    const dateLabel = $day.text().trim();
    const dayIso = $day.data('iso');
    const rangeLabel = $time.text().trim();
    const timeHandle = $time.data('handle');

    if (mode === 'delivery') {
      const $citySelect = $('#citySelect');
      const $cityOption = $citySelect.find('option:selected');
      // Read the bare city from data-city; option text is decorated with " — ₪price"
      const cityName = ($cityOption.attr('data-city') || $cityOption.text() || '').trim();
      const cityValue = $citySelect.val(); // zone title

      if (!cityName || !cityValue) {
        return null;
      }

      return {
        mode,
        dateLabel,
        dayIso,
        rangeLabel,
        timeHandle,
        city: cityName,
        cityValue
      };
    } else if (mode == 'pickup') {
      const $storeBtn = $('#select_pickup .store_select .store-btn.selected');
      const storeName = ($storeBtn.text() || '').trim();
      const storeHandle = $storeBtn.data('handle');

      if (!storeName || !storeHandle) {
        return null;
      }

      return {
        mode,
        dateLabel,
        dayIso,
        rangeLabel,
        timeHandle,
        store: storeName,
        storeHandle
      };
    } else {
      const $citySelect = $('#fastCitySelect');
      // The option's value attribute holds the bare city name (set by Liquid);
      // option text is decorated with " — ₪price" by post-init code.
      const cityValue = ($citySelect.val() || '').trim();
      const cityName = cityValue;

      return {
        mode,
        city: cityName,
        cityValue
      };
    }
  }

  function saveDeliverySelection(selection) {
    localStorage.setItem('localDeliveryHeader', JSON.stringify(selection));
  }

  function updateHeaderDeliveryStatus() {
    const $status = $('#header_delivery_status');
    const $startBtn = $('#header_delivery_button');
    const $changeBtn = $('#header_change_delivery_button');
    if (!$status.length) return;

    const data = getSavedSelection();

    if (!data || !data.mode) {
      $status.text('כדי להתחיל להזמין יש לבחור תאריך ואופן אספקה');
      $startBtn.show();
      $changeBtn.hide();
      return;
    }

    if (data.mode === 'delivery' && data.city) {
      $status.text(
        `משלוח - ${data.dateLabel} בין השעות ${data.rangeLabel} ל${data.city}`
      );
    } else if (data.mode === 'pickup' && data.store) {
      $status.text(
        `איסוף עצמי - ${data.dateLabel} בין השעות ${data.rangeLabel} מסניף ${data.store}`
      );
    } else if (data.mode === 'fast' && data.city) {
      $status.text(
        `משלוח מהיר מעכשיו לעכשיו - ל${data.city}`
      );
    } else {
      $status.text('כדי להתחיל להזמין יש לבחור תאריך ואופן אספקה');
      $startBtn.show();
      $changeBtn.hide();
      return;
    }

    // Holiday minimum-order note — shown as soon as a gated date is selected,
    // regardless of current cart size, so the customer sees it before checkout.
    // Short bracket text matches the checkout button's caption (cart-summary.liquid);
    // full explanation (holidayMin.blockingMessage) is a native hover tooltip here,
    // not inline — this element isn't inside a disabled control, so a plain
    // title attribute works (unlike the button, see cart-summary.liquid).
    const holidayMin = data.dayIso ? findHolidayMinimum(data.dayIso) : null;
    if (holidayMin) {
      $status.append(
        $('<div class="holiday-minimum-note"></div>')
          .text(`(מינימום הזמנה בתאריך הזה - ${holidayMin.amount} ש״ח)`)
          .attr('title', holidayMin.blockingMessage)
      );
    }

    $startBtn.hide();
    $changeBtn.show();
  }

  function preselectFromSavedSelection() {
    const data = getSavedSelection();

    if (!data) return;

    const mode = data.mode
    let blockId = 'select_shipping'
    if(mode == 'fast') blockId = 'select_fast'
    if (mode == 'pickup') blockId = 'select_pickup'

    // switch tab + content to correct mode
    $('.shipping_tab').removeClass('active');
    $('.shipping_selector_content_block').removeClass('active');
    $(`.shipping_tab[data-open="${blockId}"]`).addClass('active');
    $('#' + blockId).addClass('active');
    $('.shipping_selector_content').attr('data-active', blockId);

    const $block = $('#' + blockId);

    // select day (this will re-render time buttons via click handler)
    const $dayBtn = $block.find(`.day-btn[data-iso="${data.dayIso}"]`);
    if ($dayBtn.length) $dayBtn.trigger('click');;

    // after times are built, select time + city/store
    setTimeout(function () {
      const $timeBtn = $block.find(
        `.time-btn[data-handle="${data.timeHandle}"]`
      );
      if ($timeBtn.length) {
        $timeBtn.trigger('click');
      }

      if (mode === 'delivery' && data.cityValue) {
        const $select = $('#citySelect');
        if ($select.length) {
          $select.val(data.cityValue).trigger('change');
        }
      }

      if (mode === 'fast' && data.cityValue) {
        const $select = $('#fastCitySelect')

        if ($select.length) {
          $select.val(data.cityValue).trigger('change');
        }
      }

      if (mode === 'pickup' && data.store) {
        const $storeBtn = $('#select_pickup .store-btn').filter(function () {
          return $(this).text().trim() === data.store;
        });
        if ($storeBtn.length) {
          $('#select_pickup .store-btn').removeClass('selected');
          $storeBtn.addClass('selected');
        }
      }
    }, 0);
  }

  /********************
   * TIME / DAY BUILDERS
   ********************/
  const pad2 = (n) => String(n).padStart(2, '0');
  const HEB_DAYS = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];

  function buildTimeRanges(
    { startHour = 8, endHour = 18, stepMinutes = 120 } = {}
  ) {
    const ranges = [];
    const stepH = stepMinutes / 60;

    for (let h = startHour; h < endHour; h += stepH) {
      const start = `${pad2(h)}:00`;
      const end = `${pad2(h + stepH)}:00`;
      ranges.push({
        start,
        end,
        label: `${start} - ${end}`,
        handle: `${pad2(h)}-${pad2(h + stepH)}`
      });
    }
   
    return ranges;
  }

  function mergeTimeRanges(...rangeLists) {
    const byHandle = new Map();
    rangeLists.flat().forEach((range) => {
      if (range && range.handle) byHandle.set(range.handle, range);
    });
    return [...byHandle.values()].sort((a, b) => a.start.localeCompare(b.start));
  }

  function getPickupExceptionsForDate(dayIso) {
    const exceptions = Array.isArray(window.pickupScheduleExceptions)
      ? window.pickupScheduleExceptions
      : [];

    return exceptions.filter((exception) => exception.date === dayIso);
  }

  function getPickupException(dayIso, storeHandle) {
    const exceptions = getPickupExceptionsForDate(dayIso);

    return exceptions.find((exception) =>
      exception.store_handle === storeHandle
    ) || null;
  }

  function getOpenPickupExceptionRanges(dayIso) {
    const exceptions = getPickupExceptionsForDate(dayIso);

    return exceptions
      .filter((exception) =>
        exception.availability === 'open' &&
        Number.isInteger(Number(exception.start_hour)) &&
        Number.isInteger(Number(exception.end_hour)) &&
        Number(exception.start_hour) < Number(exception.end_hour)
      )
      .flatMap((exception) => buildTimeRanges({
        startHour: Number(exception.start_hour),
        endHour: Number(exception.end_hour),
        stepMinutes: Number(exception.step_minutes) || 120
      }));
  }

  function pickupStoreIsAvailableForSlot(store, dayIso, slotHandle, weekDay) {
    const exception = getPickupException(dayIso, store.handle);

    if (exception?.availability === 'closed') return false;

    if (exception?.availability === 'open') {
      return buildTimeRanges({
        startHour: Number(exception.start_hour),
        endHour: Number(exception.end_hour),
        stepMinutes: Number(exception.step_minutes) || 120
      }).some((range) => range.handle === slotHandle);
    }

    return store.weekdays.includes(weekDay);
  }

  function hasPickupStoreForSlot(dayIso, slotHandle, weekDay) {
    const stores = window.localDeliveryCapacity?.pickup?.stores || [];
    return stores.some((store) =>
      pickupStoreIsAvailableForSlot(store, dayIso, slotHandle, weekDay)
    );
  }

  // Temporary holiday policy: bookings made through 4 October 2026 require
  // 48 hours' notice for Sunday–Thursday delivery/pickup dates. Friday stays
  // on the normal cutoff cycle so both Friday slots remain available through
  // Thursday 12:00.
  const HOLIDAY_48H_POLICY_END_ISO = '2026-10-04';
  const HOUR_IN_MS = 60 * 60 * 1000;

  function localIsoDate(date) {
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  }

  function isHoliday48HourPolicyActive(from) {
    return localIsoDate(from) <= HOLIDAY_48H_POLICY_END_ISO;
  }

  function isFriday(dayIso) {
    return Boolean(dayIso) && new Date(`${dayIso}T12:00:00`).getDay() === 5;
  }

  // Cutoff pivot hour for a given order-placed date, in priority order:
  //   1. Per-date staff override — delivery_exceptions[orderDateIso].cutoff_hour
  //      (admin-editable; e.g. extend today's cutoff to 14:00 for one day)
  //   2. Thursday default — 12:00, so both Friday windows (08:00-11:00 and
  //      11:00-14:00) remain available through Thursday noon. Friday has no
  //      third window.
  //   3. All other days — 12:00 (standard noon cutoff)
  function getCutoffHour(from) {
    const iso = `${from.getFullYear()}-${pad2(from.getMonth() + 1)}-${pad2(from.getDate())}`;
    const override = window.deliveryExceptions && window.deliveryExceptions[iso] && window.deliveryExceptions[iso].cutoff_hour;
    if (override != null && override !== '') return Number(override);
    if (from.getDay() === 4) return 12; // Thursday
    return 12;
  }

  // Returns the earliest Date a slot's start may be given the current clock.
  // Through 4 October, Sunday–Thursday slots require 48 hours' notice. Friday
  // is deliberately exempt and keeps the normal Thursday-noon / +24h cycle.
  // From 5 October onward, every day uses the normal cycle again.
  // cutoff:00:00 exactly counts as "before cutoff" per product decision.
  function getMinSlotStart(from = new Date(), dayIso = null) {
    if (isHoliday48HourPolicyActive(from) && dayIso && !isFriday(dayIso)) {
      return new Date(from.getTime() + 48 * HOUR_IN_MS);
    }

    const noon = new Date(from);
    noon.setHours(getCutoffHour(from), 0, 0, 0);
    const isAfternoon = from > noon;
    const tomorrow = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 1);
    if (!isAfternoon) return tomorrow;
    const plus24h = new Date(from.getTime() + 24 * HOUR_IN_MS);
    return plus24h > tomorrow ? plus24h : tomorrow;
  }

  function buildDays(
    { from = new Date(), startOffsetDays = 1, monthsForward = 2 } = {}
  ) {
    const start = new Date(from);
    start.setDate(start.getDate() + startOffsetDays);
    const end = new Date(
      start.getFullYear(),
      start.getMonth() + monthsForward,
      start.getDate()
    );

    const out = [];
    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
      const yyyy = d.getFullYear();
      const mm = pad2(d.getMonth() + 1);
      const dd = pad2(d.getDate());
      out.push({
        date: new Date(d),
        iso: `${yyyy}-${mm}-${dd}`,
        label: `יום ${HEB_DAYS[d.getDay()]}, ${dd}.${mm}`,
        weekday: d.getDay(),
        isSaturday: d.getDay() === 6,
        isFriday: d.getDay() === 5
      });
    }
    return out;
  }

  /********************
   * LocalDeliveryPicker
   ********************/
  const LocalDeliveryPicker = (function () {
    class TimePicker {
      constructor(options = {}) {
        this.dayContainerSel = options.dayContainer ?? '.days_slider';
        this.timeContainerSel = options.timeContainer ?? '.time_slider';
        this.citySelectSel = options.citySelect ?? null; // only for delivery

        this.mode = options.mode ?? 'delivery'; // 'delivery' | 'pickup'

        this.disableSaturdays = options.disableSaturdays ?? true;
        this.disableFridays = options.disableFridays ?? true;
        this.disableFridays = false

        this.startOffsetDays = options.startOffsetDays ?? 1;
        this.monthsForward = options.monthsForward ?? 2;
        this.defaultTimeRange =
          options.defaultTimeRange ?? {
            startHour: 8,
            endHour: 18,
            stepMinutes: 120
          };

        this.zones = options.zones ?? [];
        this.specialDays = window.deliveryExceptions

        this.getDaySlotState = options.getDaySlotState ?? null;
        this.onSelect = options.onSelect ?? function () {};
        this.onSlotSelected = options.onSlotSelected ?? function () {};

        this.state = {};
      }

      init() {
        this.$days = $(this.dayContainerSel);
        this.$times = $(this.timeContainerSel);
        this.$city = this.citySelectSel ? $(this.citySelectSel) : $();

        if (!this.$days.length || !this.$times.length) return;

        if (this.$city.length && this.zones.length) {
          this.buildCitySelect();
          this.$city.prop('disabled', true).addClass('disabled');
        }

        this.renderDayButtons();

        // Re-render when an expired selection is cleared at cart submit.
        $(document).on('pitzi:selectionExpired', () => {
          this.state = {};
          this.renderDayButtons();
          this.$times.empty();
        });
      }

      buildCitySelect() {
        if (!this.$city.length) return;

        const dayIso = this.state?.dayIso || null;
        const slotHandle = this.state?.slot?.handle || null;

        const allOptions = [];

        this.zones.forEach((z) => {
          (z.cities || []).forEach((cityName) => {
            allOptions.push({
              city: cityName,
              zoneCapacity: z.capacity,
              zoneTitle: z.title,
              zonePrice: z.zone_price
            });
          });
        });

        this.$city.empty();
        this.$city.append('<option value="">בחר עיר...</option>');

        allOptions.sort((a, b) => a.city.localeCompare(b.city, 'he'));
        const zonesUsage = window.localDeliveryUsage.delivery.zones

        allOptions.forEach(({ city, zoneTitle, zoneCapacity, zonePrice }) => {
          let disabled = false;
          let title = '';
          let zoneUsage = zonesUsage.find((z) => z.label === zoneTitle)

          if (dayIso && slotHandle) {
            const usageSlot = zoneUsage?.slots?.[dayIso]?.[slotHandle];

            if (usageSlot && usageSlot.used >= zoneCapacity ) {
              disabled = true;
              title = 'המועד שנבחר מלא לאזור זה';
            }
          }

          const priceNum = Number(zonePrice);
          const label = Number.isFinite(priceNum) && priceNum > 0
            ? `${city} — ₪${priceNum}`
            : city;

          const $opt = $('<option>')
            .val(zoneTitle)
            .text(label)
            .attr('data-city', city);

          if (disabled) {
            $opt.prop('disabled', true);
            if (title) $opt.attr('title', title);
          } else if (title) {
            $opt.attr('title', title);
          }

          this.$city.append($opt);
        });

        // Avoid stacking event listeners when we rebuild
        this.$city.off('change.shipping').on('change.shipping', () => {
          const $sel = this.$city.find('option:selected');
          const zoneHandle = $sel.val();
          const cityName = $sel.data('city');

          if (!zoneHandle) return;

          this.state.zone = zoneHandle;
          this.state.city = cityName;
        });
      }

      renderDayButtons() {
        const days = buildDays({
          // startOffsetDays: this.startOffsetDays,
          monthsForward: this.monthsForward
        });

        console.log(days)

        this.$days.empty();

        days.forEach((day, index) => {
          const $btn = $('<button>', {
            type: 'button',
            class: 'day-btn',
            text: day.label
          }).attr('data-iso', day.iso);

          /*if (index <= 1) {
            $btn.prop('disabled', true).attr('hidden', true);
          }*/

          if (this.disableSaturdays && day.isSaturday) {
            $btn.prop('disabled', true).attr('hidden', true);
          }
          if (this.disableFridays && day.isFriday) {
            $btn.prop('disabled', true).attr('hidden', true);
          }
          
          const sp = this.specialDays[day.iso];
          if (sp) {
            console.log(day.iso)
            console.log(sp)
            if (sp.fully_closed == 'true')
              $btn.prop('disabled', true).attr('hidden', true)
            else
            $btn.prop('disabled', false).attr('hidden', false)
          }

          // Special cutoff rules for Pesach period:
          // - March 31: available until March 30 morning, then disabled
          // - April 1:  available until March 31 morning, then disabled
          const mmdd = day.iso.slice(5); // "MM-DD"
          const year = parseInt(day.iso.slice(0, 4));
          const now = new Date();

          if (mmdd === '03-31') {
            const cutoff = new Date(year, 2, 30, 8, 0, 0); // March 30 08:00
            if (now >= cutoff) {
              $btn.prop('disabled', true).attr('hidden', true);
            }
          }

          if (mmdd === '04-01') {
            const cutoff = new Date(year, 2, 31, 8, 0, 0); // March 31 08:00
            if (now >= cutoff) {
              $btn.prop('disabled', true).attr('hidden', true);
            }
          }

          // Hide a day only if even the last slot of the default range fails lead time.
          // Uses defaultTimeRange as a conservative baseline — avoids NaN from
          // empty weekdaySchedule entries, and is safe for days far in the future.
          if (!$btn.prop('disabled')) {
            const tr = this.defaultTimeRange;
            const stepH = (tr.stepMinutes || 120) / 60;
            const lastSlotStart = new Date(`${day.iso}T${pad2(tr.endHour - stepH)}:00:00`);
            if (lastSlotStart < getMinSlotStart(new Date(), day.iso)) $btn.prop('disabled', true).attr('hidden', true);
          }

          $btn.on('click', () => this.handleDayClick($btn, day));
          this.$days.append($btn);
        });
      }

      async handleDayClick($btn, day) {
        this.$days.find('.day-btn.selected').removeClass('selected');
        $btn.addClass('selected');

        this.state.dayIso = day.iso;
        this.state.slot = null;

        const sp = this.specialDays[day.iso];
        const weekdayName = new Date(day.iso).toLocaleDateString('en-US', { weekday: 'long' });
        const ws = (window.weekdaySchedule || {})[weekdayName];

        let baseRange;
        let usingScheduleOverride = false;

        if (sp && sp.start_time && sp.end_time) {
          baseRange = {
            startHour: parseInt(sp.start_time),
            endHour: parseInt(sp.end_time),
            stepMinutes: parseInt(sp.step_minutes) || 120
          };
          usingScheduleOverride = true;
        } else if (ws && ws.start_hour != null && ws.end_hour != null) {
          baseRange = {
            startHour: parseInt(ws.start_hour),
            endHour: parseInt(ws.end_hour),
            stepMinutes: parseInt(ws.step_minutes) || 120
          };
          usingScheduleOverride = true;
        } else {
          baseRange = this.defaultTimeRange;
        }

        this.state.usingScheduleOverride = usingScheduleOverride;

        let slotState = {};
        if (typeof this.getDaySlotState === 'function') {
          try {
            slotState = (await this.getDaySlotState(day.iso)) || {};
          } catch (e) {
            console.warn(e);
          }
        }

        this.renderTimeButtons(day.iso, baseRange, slotState);
      }

      renderTimeButtons(dayIso, rangeConfig, slotStateMap = {}) {
        this.$times.empty();
        const pickupExceptionRanges = this.mode === 'pickup'
          ? getOpenPickupExceptionRanges(dayIso)
          : [];
        const pickupExceptionHandles = new Set(
          pickupExceptionRanges.map((range) => range.handle)
        );
        const ranges = mergeTimeRanges(
          buildTimeRanges(rangeConfig),
          pickupExceptionRanges
        );
        
        const selectedDate = new Date(dayIso);
        const weekDay = selectedDate.toLocaleDateString("en-US", { weekday: "long" });
        const timeSlots = window.timeSlots;

        // Special override days use custom time ranges, skip timeSlots weekday check.
        // Driven by an exception entry or weekday_schedule entry — set in handleDayClick.
        const isSpecialDay = this.state.usingScheduleOverride === true;

        const today = new Date();
        const isToday = today.toDateString() === selectedDate.toDateString();
        
        const currentTotalMinutes = today.getHours() * 60 + today.getMinutes();

        ranges.forEach((r) => {
          const $btn = $('<button>', {
            type: 'button',
            class: 'time-btn',
            text: r.label
          })
            .attr('data-start', r.start)
            .attr('data-end', r.end)
            .attr('data-handle', r.handle);

          const state = slotStateMap[r.handle];

          // Skip timeSlots weekday check for special override days (e.g. April 1st)
          const isPickupExceptionSlot = pickupExceptionHandles.has(r.handle);
          if (!isSpecialDay && !isPickupExceptionSlot && (!timeSlots[r.handle] || !timeSlots[r.handle].includes(weekDay))) {
            $btn.prop('disabled', true);
          }

          // Only filter all unusable pickup slots once the date has exception
          // data. This prevents a misconfigured/unreadable exception from
          // producing an empty time picker.
          const hasPickupExceptionForDate = getPickupExceptionsForDate(dayIso).length > 0;
          if (this.mode === 'pickup' && hasPickupExceptionForDate && !hasPickupStoreForSlot(dayIso, r.handle, weekDay)) {
            $btn.prop('disabled', true).attr('hidden', true);
          }

          if (isToday && r.start) {
            const [startHours, startMinutes] = r.start.split(':').map(Number);
            const startTotalMinutes = (startHours * 60) + (startMinutes || 0);

            if (currentTotalMinutes >= startTotalMinutes) {
              $btn.prop('disabled', true);
              $btn.attr('title', 'זמן זה עבר');
            }
          }

          // Lead-time enforcement: temporary 48h rule for Sunday–Thursday
          // through 4 October; Friday keeps its Thursday-noon exception.
          const slotStart = new Date(`${dayIso}T${r.start}:00`);
          const minStart = getMinSlotStart(new Date(), dayIso);
          if (slotStart < minStart) {
            $btn.prop('disabled', true);
            $btn.attr('title', isHoliday48HourPolicyActive(new Date()) && !isFriday(dayIso)
              ? 'דרושות 48 שעות הזמנה מראש'
              : 'דרושות 24 שעות הזמנה מראש');
          }

          if (state && state.disabled) {
            $btn.prop('disabled', true);
            if (state.reason) $btn.attr('title', state.reason);
          } else if (state && typeof state.left === 'number') {
            $btn.attr('title', `נותרו ${state.left} מקומות`);
          }

          $btn.on('click', () => {
            this.$times.find('.time-btn.selected').removeClass('selected');
            $btn.addClass('selected');

            this.state.slot = r;

            if (this.mode === 'pickup') {
              buildStoresForSlot(this.state.dayIso, r.handle, weekDay);
            }

            if (this.$city.length) {
              this.buildCitySelect();
              this.$city.prop('disabled', false).removeClass('disabled');
            }

            this.onSlotSelected?.({ dayIso, range: r });
          });

          this.$times.append($btn);
        });
      }
    }

    return { TimePicker };
  })();

  /********************
   * CAPACITY + USAGE COMBINED
   ********************/

  function getLocalDeliveryUsageConfig() {
    return window.localDeliveryUsage || null;
  }

  /**
   * Combine capacity (metaobjects) + used (shop metafield local_delivery)
   */
function getSlotAvailability(mode, handle, dayIso, slotHandle) {
  const capacityConfig = window.localDeliveryCapacity || {};
  const usageConfig = getLocalDeliveryUsageConfig() || {};
  const isDelivery = mode === 'delivery';

  // Helper: find zone/store by handle OR label
  function findByHandleOrLabel(list, handleOrLabel) {
    if (!Array.isArray(list)) return null;
    return list.find(
      (item) =>
        item.handle === handleOrLabel ||
        item.label === handleOrLabel
    );
  }

  // ---- CAPACITY FROM METAOBJECTS ----
  let capacityContainer;
  if (isDelivery) {
    capacityContainer = capacityConfig.delivery?.zones || [];
  } else {
    capacityContainer = capacityConfig.pickup?.stores || [];
  }

  const capacityItem = findByHandleOrLabel(capacityContainer, handle);
  const capSlotObj = capacityItem?.slots?.[dayIso]?.[slotHandle];

  const capacity =
    capSlotObj && typeof capSlotObj.capacity === 'number'
      ? capSlotObj.capacity
      : null;

  // ---- USED FROM SHOP METAFIELD local_delivery ----
  let used = 0;

  if (usageConfig && dayIso && slotHandle) {
    if (isDelivery) {
      const zonesArr = usageConfig.delivery?.zones || [];
      const zone = findByHandleOrLabel(zonesArr, handle);
      const slotObj = zone?.slots?.[dayIso]?.[slotHandle];
      if (slotObj && typeof slotObj.used === 'number') {
        used = slotObj.used;
      }
    } else {
      const storesArr = usageConfig.pickup?.stores || [];
      const store = findByHandleOrLabel(storesArr, handle);
      const slotObj = store?.slots?.[dayIso]?.[slotHandle];
      if (slotObj && typeof slotObj.used === 'number') {
        used = slotObj.used;
      }
    }
  }

  // No capacity defined for this slot in metaobject -> treat as full (current behavior)
  if (capacity == null) {
    return { capacity: null, used, available: 0, isFull: true };
    // If you ever want "no capacity means unlimited", change to:
    // return { capacity: null, used, available: null, isFull: false };
  }

  const available = Math.max(capacity - used, 0);
  const isFull = available <= 0;

  return { capacity, used, available, isFull };
}


  /********************
   * PICKUP STORES BUILDER (WITH CAPACITY)
   ********************/
  function buildStoresForSlot(dayIso, slotHandle, weekDay) {
      const stores = window.localDeliveryCapacity.pickup.stores || [];
      const $wrapper = $('#select_pickup .store_select');

      $wrapper.empty();
      const storesUsage = window.localDeliveryUsage.pickup.stores

      stores.forEach((store) => {
          const title = store.title;
          const storeUsage = storesUsage.find((z) => z.label == title)
          const usageSlot = storeUsage?.slots?.[dayIso]?.slotHandle
          const exception = getPickupException(dayIso, store.handle);
          const isOpenByException = exception?.availability === 'open' &&
            pickupStoreIsAvailableForSlot(store, dayIso, slotHandle, weekDay);

          let disabled = false
          let disabledReason = '';
          if (usageSlot && usageSlot >= store.capacity) {
              disabled = true
              disabledReason = 'המועד שנבחר מלא בסניף זה';
          }

          if (exception?.availability === 'closed') {
            disabled = true;
            disabledReason = 'האיסוף סגור בסניף זה בתאריך שנבחר';
          } else if (exception?.availability === 'open' && !isOpenByException) {
            disabled = true;
            disabledReason = 'שעת האיסוף אינה זמינה בסניף זה בתאריך שנבחר';
          } else if (!exception && !store.weekdays.includes(weekDay)) {
            disabled = true
            disabledReason = 'האיסוף אינו זמין בסניף זה ביום שנבחר';
          }

          const $btn = $('<button>', {
              type: 'button',
              class: 'store-btn',
              text: title
          }).attr('data-handle', title);

          if (disabled) {
              $btn.prop('disabled', true);
              $btn.attr('title', disabledReason || 'המועד שנבחר אינו זמין בסניף זה');
          }

          $btn.on('click', function() {
            if (disabled) return;
            $('#select_pickup .store-btn.selected').removeClass('selected');
            $(this).addClass('selected');
          });

          $wrapper.append($btn);
      })
  };

  function isSlotExpired(data) {
      if (!data) return false;

      // Fast mode has no time slot, skip expiry check
      if (data.mode === 'fast') return false;

      if (!data.dayIso || !data.timeHandle) return false;

      // Lead-time check at cart submit — mirrors buildDays/renderTimeButtons.
      // Re-validates because the picker's view can age past the noon cutoff
      // while the cart sits open (e.g. slot picked at 11:55, paid at 12:05).
      var startHour = data.timeHandle.split('-')[0];
      var slotStart = new Date(data.dayIso + 'T' + startHour.padStart(2, '0') + ':00:00');
      if (slotStart < getMinSlotStart(new Date(), data.dayIso)) return true;

      // Check if the time slot itself has passed
      var endHour = data.timeHandle.split('-')[1];
      var endDateTime = new Date(data.dayIso + 'T' + endHour.padStart(2, '0') + ':00:00');
      if (new Date() > endDateTime) return true;

      // Check Pesach cutoff rules:
      // - March 31 orders disabled after March 30 08:00
      // - April 1 orders disabled after March 31 08:00
      var mmdd = data.dayIso.slice(5);
      var year = parseInt(data.dayIso.slice(0, 4));
      var now = new Date();

      if (mmdd === '03-31') {
        var cutoff = new Date(year, 2, 30, 8, 0, 0);
        if (now >= cutoff) return true;
      }

      if (mmdd === '04-01') {
        var cutoff = new Date(year, 2, 31, 8, 0, 0);
        if (now >= cutoff) return true;
      }

      return false;
  }

  /********************
   * COLLECTION AVAILABILITY WINDOW (e.g. holiday edition)
   ********************/
  // Returns the first cart line whose delivery window excludes checkIso, else null.
  // Windows are rendered server-side onto each line-item <tr> as data-delivery-* in
  // snippets/cart-products.liquid, so they survive morph.js cart re-renders.
  // Scoped to the submitting form to avoid the duplicate cart DOM on the /cart page.
  function findOutOfWindowLine(form, checkIso) {
    if (!checkIso) return null;
    var scope = form || document;
    var rows = scope.querySelectorAll(
      '.cart-items__table-row[data-delivery-from][data-delivery-until]'
    );
    for (var i = 0; i < rows.length; i++) {
      var from = rows[i].getAttribute('data-delivery-from');
      var until = rows[i].getAttribute('data-delivery-until');
      if (!from || !until) continue;
      // ISO YYYY-MM-DD strings compare lexicographically.
      if (checkIso < from || checkIso > until) {
        return {
          from: from,
          until: until,
          title: rows[i].getAttribute('data-delivery-title') || '',
          msg: rows[i].getAttribute('data-delivery-msg') || ''
        };
      }
    }
    return null;
  }

  function composeWindowMessage(line) {
    if (line.msg) return line.msg;
    function fmt(iso) {
      var p = iso.split('-');
      return p[2] + '.' + p[1] + '.' + p[0];
    }
    var name = line.title || 'מהדורת החג';
    return name + ' זמינה למשלוח לתאריכים ' + fmt(line.from) + ' עד ' + fmt(line.until) +
      ' בלבד. אנא בחרו תאריך אספקה בטווח זה.';
  }

  /********************
   * PER-PRODUCT BLOCKED DELIVERY DATES (single-day blackout, e.g. kitchen closed
   * one specific day). Independent of the availability window above: that one
   * defines a continuous range the product IS deliverable in; this one lists
   * individual dates it is NOT deliverable on, with the product open otherwise.
   ********************/
  // Returns the first cart line whose blocked-dates list contains checkIso, else null.
  // Rendered server-side onto each line-item <tr> as data-blocked-* in
  // snippets/cart-products.liquid, so it survives morph.js cart re-renders.
  // Scoped to the submitting form to avoid the duplicate cart DOM on the /cart page.
  function findBlockedDateLine(form, checkIso) {
    if (!checkIso) return null;
    var scope = form || document;
    var rows = scope.querySelectorAll('.cart-items__table-row[data-blocked-dates]');
    for (var i = 0; i < rows.length; i++) {
      var raw = rows[i].getAttribute('data-blocked-dates') || '';
      var dates = raw.split(',');
      if (dates.indexOf(checkIso) !== -1) {
        return {
          date: checkIso,
          title: rows[i].getAttribute('data-blocked-title') || '',
          msg: rows[i].getAttribute('data-blocked-msg') || ''
        };
      }
    }
    return null;
  }

  function composeBlockedMessage(line) {
    if (line.msg) return line.msg;
    function fmt(iso) {
      var p = iso.split('-');
      return p[2] + '.' + p[1] + '.' + p[0];
    }
    var name = line.title || 'המוצר';
    return name + ' אינו זמין לאספקה בתאריך ' + fmt(line.date) + '. אנא בחרו תאריך אספקה אחר.';
  }

  /********************
   * HOLIDAY MINIMUM ORDER (date-gated cart minimum, e.g. chag)
   ********************/
  // Returns window.holidayMinimumOrder if dayIso is one of its configured dates,
  // else null. Config is entirely data-driven (Content → Metaobjects →
  // Holiday Minimum Order) — no dates/amount/copy are hardcoded here.
  function findHolidayMinimum(dayIso) {
    var hmo = window.holidayMinimumOrder;
    if (!hmo || !dayIso || !Array.isArray(hmo.dates)) return null;
    return hmo.dates.indexOf(dayIso) !== -1 ? hmo : null;
  }

  // Today's date as YYYY-MM-DD (matches the picker's local-Date convention).
  function todayIso() {
    var n = new Date();
    var m = String(n.getMonth() + 1).padStart(2, '0');
    var d = String(n.getDate()).padStart(2, '0');
    return n.getFullYear() + '-' + m + '-' + d;
  }

  /********************
   * BOOTSTRAP
   ********************/
  $(document).ready(function () {
    try {
      const zones  = window.localDeliveryCapacity.delivery.zones || [];
      const stores = window.localDeliveryCapacity.pickup.stores || [];

      const deliveryPicker = new LocalDeliveryPicker.TimePicker({
        mode:         'delivery',
        citySelect:   '#select_shipping .city_select',
        dayContainer: '#select_shipping .days_slider',
        timeContainer:'#select_shipping .time_slider',
        zones,
        specialDays: {},
        getDaySlotState: async () => {
          return {};
        }
      });

      const pickupPicker = new LocalDeliveryPicker.TimePicker({
        mode:         'pickup',
        dayContainer: '#select_pickup .days_slider',
        timeContainer:'#select_pickup .time_slider',
        specialDays: {},
        getDaySlotState: async () => {
          return {};
        }
      });

      const fastPicker = new LocalDeliveryPicker.TimePicker({
        mode:          'fast',
        citySelect:    '#fastCitySelect',
        dayContainer:  'none',
        timeContainer: 'none',
        specialDays: {},
        getDaySlotState: async () => {
          return {};
        }
      });

      deliveryPicker.init();
      pickupPicker.init();
      fastPicker.init()

      // Decorate the fast-mode city dropdown with each city's zone price.
      // Cities here come from the fast_delivery metaobject; we resolve the
      // price via the zone_capacity metaobject (same data the delivery tab uses).
      $('#fastCitySelect option').each(function () {
        const $opt = $(this);
        const cityName = ($opt.attr('value') || '').trim();
        if (!cityName) return;
        const zoneTitle = findZoneTitleForCity(cityName);
        if (!zoneTitle) return;
        const zones = (window.localDeliveryCapacity && window.localDeliveryCapacity.delivery && window.localDeliveryCapacity.delivery.zones) || [];
        const zone = zones.find((z) => z.title === zoneTitle);
        const priceNum = zone ? Number(zone.zone_price) : NaN;
        if (Number.isFinite(priceNum) && priceNum > 0) {
          $opt.text(`${cityName} — ₪${priceNum}`);
        }
      });

      const savedSelection = getSavedSelection();
      
      if (isSlotExpired(savedSelection)) {
        localStorage.removeItem('localDeliveryHeader');
      }

      preselectFromSavedSelection();

      // Mobile scroll-hint (T13): hide the nudge chevron once the customer scrolls
      // the date row, and drop the edge fade when scrolled to the far end.
      // RTL scrollLeft conventions differ across browsers, so distance is read via
      // Math.abs against the max scrollable width.
      $('.days_slider').each(function () {
        const slider = this;
        const $hint = $(slider).nextAll('.days_scroll_hint').first();
        let nudged = false;
        slider.addEventListener('scroll', function () {
          if (!nudged) { $hint.addClass('is-hidden'); nudged = true; }
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          const atEnd = Math.abs(maxScroll - Math.abs(slider.scrollLeft)) < 4;
          $(slider).toggleClass('is-scroll-end', atEnd);
        }, { passive: true });
      });

    } catch (e) {
      console.error('Error bootstrapping delivery picker:', e);
    }
  });
})(jQuery);
